import Hero from '../components/Hero/Hero';
import BodySection from '../components/Features/BodySection';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero isLandingPage={true} />
      <BodySection />
    </div>
  );
};

export default Home; 